var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFemaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 11.1527C8.26428 10.9747 9.64894 10.2649 10.6221 9.16789C11.5953 8.07085 12.0838 6.669 11.9882 5.24773C11.8926 3.82645 11.2201 2.49257 10.1076 1.51764C8.99514 0.542705 7.52625 0 6 0C4.47375 0 3.00486 0.542705 1.89236 1.51764C0.779853 2.49257 0.107363 3.82645 0.011785 5.24773C-0.0837934 6.669 0.404724 8.07085 1.37789 9.16789C2.35106 10.2649 3.73572 10.9747 5.25 11.1527V12.6013H1.50001V14.0008H5.25V16.8H6.75V14.0008H10.5V12.6013H6.75V11.1527ZM1.50001 5.60338C1.50001 4.77295 1.76393 3.96117 2.25839 3.27069C2.75286 2.58022 3.45566 2.04205 4.27793 1.72426C5.10019 1.40647 6.00499 1.32332 6.8779 1.48533C7.75082 1.64734 8.55264 2.04723 9.18198 2.63443C9.81131 3.22164 10.2399 3.96978 10.4135 4.78425C10.5872 5.59873 10.498 6.44295 10.1575 7.21017C9.81686 7.97739 9.24008 8.63314 8.50006 9.0945C7.76004 9.55586 6.89001 9.80211 6 9.80211C4.80695 9.80082 3.66317 9.35804 2.81956 8.5709C1.97595 7.78377 1.5014 6.71656 1.50001 5.60338Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleIcon);
export default __webpack_public_path__ + "static/media/femaleIcon.175c6a4e0d897cb9d6b14964b91758dc.svg";
export { ForwardRef as ReactComponent };